import {Injectable} from '@angular/core';
import {Router, Resolve} from '@angular/router';
import {Observable, forkJoin, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Page} from '../page';
import {Produto} from './home/conteudo/produtos/produto';
import {ProdutosService} from './home/conteudo/produtos/produtos.service';
import {Filtro} from '../pesquisa/pesquisa/filtros/filtro';
import {FiltrosService} from '../pesquisa/pesquisa/filtros/filtros.service';

@Injectable()
export class HomeResolver implements Resolve<any> {

    constructor(
        private produtoService: ProdutosService,
        private filtroService: FiltrosService,
        private router: Router) {
    }

    resolve(): Observable<[Page<Produto>, Page<Produto>, Filtro]> {
        const filterNovidades = new Map<string, any>();
        filterNovidades.set('novidade', [true]);

        const filterProdutos = new Map<string, any>();
        filterProdutos.set('plataformas', ['web', 'mobile']);
        filterProdutos.set('exibirHome', [true]);

        const filtros = this.filtroService.getFiltro().pipe(
            map(res => {
                if (res === null) {
                    this.router.navigate(['/page-not-found']);
                    return of(null);
                }
                return res;
            }),
            catchError(err => {
                this.router.navigate(['/page-not-found']);
                return of(null);
            })
        );

        const produtos = this.produtoService.getProdutos(filterProdutos, [], 0, 8).pipe(
            map(res => {
                if (res === null) {
                    this.router.navigate(['/page-not-found']);
                    return of(null);
                }
                return res;
            }),
            catchError(err => {
                this.router.navigate(['/page-not-found']);
                return of(null);
            })
        );

        const novidades = this.produtoService.getProdutos(filterNovidades, [], 0, 4).pipe(
            map(res => {
                if (res === null) {
                    this.router.navigate(['/page-not-found']);
                    return of(null);
                }
                return res;
            }),
            catchError(err => {
                this.router.navigate(['/page-not-found']);
                return of(null);
            })
        );

        return forkJoin([produtos, novidades, filtros]);
    }

}
